/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation PhoneNumberoRoutePlanCreateMutation($input: [PhoneNumberoRoutePlanCreateInput!]!) {
  PhoneNumberoRoutePlanCreate(input: $input) {
    id,
    message,
    status
  }
}
`
